import { render, staticRenderFns } from "./ShopComponent.vue?vue&type=template&id=e42a2536&"
import script from "./ShopComponent.vue?vue&type=script&lang=ts&"
export * from "./ShopComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ShopComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports